<template>
  <div class="u-form-create">
    <Form
      ref="ruleFormRef"
      :model="ruleForm"
      :label-position="labelPosition"
      :label-width="labelWidth"
      class="demo-ruleForm"
      @submit.prevent
    >
      <slot name="before"></slot>
      <Row :gutter="20">
        <template v-for="(item, index) in ruleForm.list">
          <Col
            v-if="item.type == 'title'"
            :span="24"
            :key="'f' + item.field"
            v-show="!item.isHide"
          >
            <div class="title">{{ item.text }}</div>
          </Col>
          <Col
            v-else
            :span="item.span || 24"
            :key="'s' + item.field"
            v-show="!item.isHide"
          >
            <inputItem :index="index" :inputInfo="item" />
          </Col>
        </template>
      </Row>
      <slot name="after"></slot>
      <div class="footer">
        <Button v-if="!hideConfirmBtn" type="primary" @click="submitForm">{{
          confirmText
        }}</Button>
        <Button v-if="!hideCancelBtn" @click="close">{{ cancelText }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import inputItem from "./com/inputItem.vue";
import FormCreateTool from "./utils";
import dayjs from "dayjs";
export default {
  props: {
    labelPosition: {
      type: String,
      default: "top",
    },
    list: {
      type: Array,
      default: () => [],
    },
    hideCancelBtn: {
      type: Boolean,
      default: false,
    },
    hideConfirmBtn: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    confirmText: {
      type: String,
      default: "确定",
    },
    defaultValue: {
      type: Object,
      default: () => null,
    },
    labelWidth: {
      type: Number,
      default: 0,
    },
  },
  components: {
    inputItem,
  },
  watch: {
    defaultValue(newValue, oldValue) {
      this.init();
    },
    list(newValue, oldValue) {
      this.init();
    },
  },
  data() {
    return {
      ruleForm: {
        list: [],
      },
      collectData: {},
    };
  },
  methods: {
    init() {
      this.ruleForm.list = this.list;
      if (this.defaultValue) {
        this.setValue(this.ruleForm.list);
      }
    },
    submitForm() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleFormRef.validate((valid, e) => {
          if (valid) {
            this.collectData = {};
            this.getValue(this.ruleForm.list);
            this.$emit("submit", this.collectData);
            resolve(this.collectData);
          } else {
            this.$Message.warning("请将表单填写完整");
            reject(e);
          }
        });
      });
    },
    resetForm() {
      this.$refs.ruleFormRef.resetFields();
    },

    getValue(list) {
      list.forEach((i) => {
        if (!["title"].includes(i.type)) {
          if (i.type == "date") {
            this.collectData[i.field] = i.value
              ? dayjs(i.value, "YYYY-MM-DD")
              : "";
          } else {
            this.collectData[i.field] = i.value;
          }
        }
      });
    },

    setValue(list) {
      list.forEach((i) => {
        let value = this.defaultValue[i.field];
        if (!["title"].includes(i.type) && (value != "" || value != null)) {
          i.value = value;
        }
      });
    },

    close() {
      this.$emit("close");
    },
    tool() {
      return new FormCreateTool(this.list);
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.u-form-create {
  :deep {
    .el-autocomplete,
    .el-select,
    .iconselect-container,
    .el-date-editor,
    .el-date-editor .el-input__wrapper,
    .el-cascader {
      width: 100%;
    }
    .ivu-form-label-top {
      .ivu-form-item-label {
        white-space: nowrap;
      }
    }
    .ivu-form-item {
      margin-bottom: 10px;
      .ivu-form-item-error-tip {
        font-size: 12px;
        padding-top: 0;
      }
    }
  }
  .Form {
    margin-bottom: 0;
  }

  .footer {
    padding-top: 10px;
  }
}
</style>
